import { TasksKanbanRelatedToType } from '@ts-tasks-kanban/enums'
import { TasksKanbanStage } from '@brighterly/lib-core-types/tasks-kanban/enums'

import { useTasksKanbanStore } from '@stores/tasks-kanban'

import { useKanbanTaskCreateApi } from '@api/tasks-kanban/kanban-task-create.hook'
import { useTasksKanbanAgentsApi } from '@api/tasks-kanban/agents.hook'

import { defineNuxtRouteMiddleware } from '#app'

const isRelatedToType = (value: string): value is TasksKanbanRelatedToType =>
  Object.values(TasksKanbanRelatedToType).includes(value as TasksKanbanRelatedToType)

export default defineNuxtRouteMiddleware((to) => {
  const tasksKanbanStore = useTasksKanbanStore()

  tasksKanbanStore.clearCreationFields()
  tasksKanbanStore.setStage(TasksKanbanStage.Backlog)

  const customerId = to.query.customer_id
  const relatedToId = to.query.related_to_id
  const relatedToType = to.query.related_to_type

  if (
    typeof relatedToId === 'string'
    && typeof relatedToType === 'string'
    && isRelatedToType(relatedToType)
  ) {
    tasksKanbanStore.setRelatedTo({ id: Number(relatedToId), type: relatedToType })
  } else {
    tasksKanbanStore.setRelatedTo(null)
  }

  if (typeof customerId === 'string') {
    void useKanbanTaskCreateApi({ customer_id: customerId })
  }

  void useTasksKanbanAgentsApi()
})
